module.exports = __webpack_public_path__ + "img/icon-x-circle.61581117.svg";